
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
  });
}

@Options({
  emits: ["close"],
})
export default class ModalSuccessAcceptOrder extends Vue.with(Props) {
  onCloseModal() {
    this.$emit("close");
    this.$emit("update:modelValue", false);
  }

  async onSubmitModal() {
    this.$emit("print");
  }
}
